import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const _initialState = {
  role: "",
  capabilities: [],
  studioId: null,
  tenantId: null,
  studioName: "",
  userEmail: "",
  accessToken: "",
  isAuth: false,
  primaryColor: null,
  secondaryColor: null,
  name: "",
  surname: "",
  logoImageURL: "",
  rstPasswordRequired: false,
  appConfig: null,
  notifications: [],
  profile: {},
  adminStudios: [],
  hasMultiTenant: false
};

const appSlice = createSlice({
  name: "app",
  initialState: _initialState,
  reducers: {
    updateAppState: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.hasMultiTenant = action.payload.hasMultiTenant;
      state.userEmail =
        action.payload[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
        ];
      state.adminId =
        action.payload[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ];
      state.isAuth = true;
      state.name =
        action.payload[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
        ];
      state.surname =
        action.payload[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"
        ];
      state.rstPasswordRequired = action.payload.resetPasswordRequired;
      state.adminStudios = action.payload.adminStudios;

      if (Array.isArray(state.adminStudios) && state.adminStudios.length > 0) {
        state.studioId = state.adminStudios[0].studioId;
        state.studioName = state.adminStudios[0].studioName;
        state.tenantId = state.adminStudios[0].tenantId;
        state.capabilities = state.adminStudios[0].capabilities;

        // Determina il ruolo basato sulle capabilities
        if (Array.isArray(state.capabilities)) {
          if (state.capabilities.includes('Admin')) {
            state.role = 'Admin';
          } else if (state.capabilities.includes('GroupAdmin')) {
            state.role = 'Admin';
            state.subRole = "GroupAdmin";
          }
          else if (state.capabilities.includes('Studio')) {
            state.role = 'Studio';
          } else if (state.capabilities.includes('Operator')) {
            state.role = 'Operator';
          }
        } else {
          state.role = 'User';
        }
      }

    },
    updateStudioName: (state, action) => {
      state.studioName = action.payload.studioName;
    },
    updateEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setColors: (state, action) => {
      state.primaryColor = action.payload.primaryColor;
      state.secondaryColor = action.payload.secondaryColor;
    },
    setStudioId: (state, action) => {
      state.studioId = action.payload.studioId;
    },
    setTenantId: (state, action) => {
      state.tenantId = action.payload.tenantId;
    },
    setLogoImageURL: (state, action) => {
      state.logoImageURL = action.payload.logoImageURL;
    },
    resetUser: (state, action) => {
      state.primaryColor = action.payload.primaryColor;
      state.secondaryColor = action.payload.secondaryColor;
      state.studioId = null;
      state.logoImageURL = null;
      state.studioName = null;
    },
    setRstPasswordRequired: (state, action) => {
      state.rstPasswordRequired = action.payload.Data.RstPasswordRequired;
    },
    setConfig: (state, action) => {
      state.appConfig = action.payload;
    },
    addNotification: (state, action) => {
      if (!Array.isArray(state.notifications)) {
        state.notifications = [];
      }
      state.notifications.push({
        ...action.payload,
      });
    },
    markAsRead: (state, action) => {
      const notification = state.notifications.find(
        (n) => n.id === action.payload
      );
      if (notification) {
        notification.rerad = true;
      }
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    setProfileData: (state, action) => {
      state.profile = {
        ...action.payload
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state = _initialState;
      return state;
    });
  },
});

export const { name, reducer, actions } = appSlice;
